@reference "@glow/tailwind-config/reference.css";

.container {
  @apply rounded-sm;
  @apply p-4;
  @apply text-base;
  @apply font-semibold;
}

.button {
  @apply flex;
  @apply justify-between;
  @apply w-full;
  @apply items-center;
  @apply text-base;
  @apply font-semibold;
}

.title {
  @apply text-left;
  @apply flex;
  @apply items-center;
  @apply gap-2;
}

.panel {
  @apply text-left;
  @apply list-disc;
  @apply pl-10;
  @apply mt-2;
}

.container.info-light {
  @apply bg-neutral-light;
}

.container.info-dark {
  @apply bg-neutral-dark;
  @apply text-neutral-light;
}

.container.loading-light,
.container.success-light {
  @apply bg-success-light;
  @apply text-success-dark;
}

.container.loading-dark,
.container.success-dark {
  @apply bg-success-dark;
  @apply text-success-light;
}

.container.error-light {
  @apply bg-danger-light;
  @apply text-danger-dark;
}

.container.error-dark {
  @apply bg-danger-dark;
  @apply text-danger-light;
}

.container.warning-light {
  @apply bg-warning-light;
  @apply text-warning-dark;
}

.container.warning-dark {
  @apply bg-warning-dark;
  @apply text-warning-light;
}

.item {
  @apply font-normal;
  @apply text-base;
}

.container.info-light .item,
.container.loading-light .item,
.container.success-light .item,
.container.warning-light .item,
.container.error-light .item {
  @apply text-emphasis-high;
}
